import { useState } from "react";
import { FaDownload } from "react-icons/fa";
import jsPDF from "jspdf";

const dummyPayslips = [
  { month: "June 2025", generatedOn: "05 July 2025", file: "#" },
  { month: "May 2025", generatedOn: "05 June 2025", file: "#" },
  { month: "April 2025", generatedOn: "05 May 2025", file: "#" },
];

const PaySlips = () => {
  const [payslips] = useState(dummyPayslips);

  const handleDownload = (slip) => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.setTextColor(34, 139, 34); // green
    doc.text("OHM Automotives Pvt. Ltd.", 20, 20);

    // Payslip Header
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text("Payslip Receipt", 20, 40);

    // Details
    doc.setFontSize(12);
    doc.text(`Month: ${slip.month}`, 20, 60);
    doc.text(`Generated On: ${slip.generatedOn}`, 20, 70);
    doc.text("Employee Name: John Doe", 20, 80);
    doc.text("Employee ID: EMP12345", 20, 90);

    // Salary Breakdown (Dummy Data)
    doc.text("Basic Salary: ₹40,000", 20, 110);
    doc.text("HRA: ₹15,000", 20, 120);
    doc.text("Conveyance: ₹5,000", 20, 130);
    doc.text("Other Allowances: ₹3,000", 20, 140);
    doc.text("Deductions: ₹5,000", 20, 150);

    doc.setFontSize(13);
    doc.setFont("helvetica", "bold");
    doc.text("Net Salary: ₹58,000", 20, 170);

    // Footer
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("This is a system-generated payslip and does not require a signature.", 20, 190);

    // Save as PDF
    doc.save(`${slip.month}_Payslip.pdf`);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">

      {/* Header */}
      <div className="text-center mb-6">
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-green-700">Pay Slips</h2>
            <p className="text-center text-red-700 mt-2 text-sm">
              🚧 Feature under development. Coming soon!
            </p>
          </div>
      </div>

      {/* Payslip List */}
      <div className="space-y-4 max-w-lg mx-auto">
        {payslips.map((slip, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-md p-4 flex justify-between items-center"
          >
            <div>
              <p className="font-semibold text-gray-800">{slip.month}</p>
              <p className="text-xs text-gray-500">
                Generated on: {slip.generatedOn}
              </p>
            </div>
            <button
              onClick={() => handleDownload(slip)}
              className="text-green-600 hover:text-green-800 text-sm flex items-center gap-1"
            >
              <FaDownload /> Download
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaySlips;
